
import { SaleType } from "@/models/base";
import { SaleService } from "@/services/sale-service";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import AppSaleTypeNew from "@/components/settings-sales/SaleTypeNew.vue";
import { AuthService } from "@/services/auth-service";
import { Tier } from "@/utils/payments/tiers";
import { MODULE } from "@/config/modules";
import {DossierConfigService} from "@/services";


export default Vue.extend({
	data(){
		return {
			createNew: false
		};
	},
	props: {
		types: {
			type: Array as ()=> SaleType[],
			required: true
		},
		contactGroupId: {
			type: Number,
			required: true
		}
	},
	computed: {
		locale(): string {
			return this.$i18n.locale;
		},
		title():TranslateResult{
			if (this.contactGroupId == 1) {
				return  this.$ct("sale-per-type");
			}else if (this.contactGroupId == 2) {
				return this.$ct("purchase-per-type");
			}
			return this.$ct("sales-per-type-prospect");
		},
		createButtonText():TranslateResult {
			if (this.contactGroupId == 1) {
				return this.$ct("create-new-sale-type");
			}else if (this.contactGroupId == 2) {
				return this.$ct("create-new-purchase-type");
			}
			return this.$ct("create-new-prospect-type");
		},
		canCreate():boolean {
			if (AuthService.wfCompany.Tier < Tier.ENTERPRISE) {
				return false;
			}
			if (!AuthService.hasModule(MODULE.EXTRA_SALE_TYPES)) {
				return false;
			}
			if (this.contactGroupId == 2 && !AuthService.hasModule(MODULE.AANKOOPFACTUREN)) {
				return false;
			}
			if (this.contactGroupId == 3 && !AuthService.hasModule(MODULE.PROSPECTEN)){
				return false;
			}
			return true;
		}
	},
	methods: {
		setOrder(){
			this.$emit("order");
		},
		getStockConfig(id:number):boolean{
			return DossierConfigService.getSaleConfig(id).ComputeStock;
		},
		openCreateModal() {
			this.createNew = true;
		},
		onNewCreated(saleType:SaleType){
			this.$router.push(`/settings/sales/types/${saleType.ID}`);
		},
		async deleteType(saleType:SaleType){
			let confirm = await this.$confirmBuilder(this.$ct("are-you-sure-you-want-to-delete-sale-type", {text: saleType.DisplayedName})).setWarningTitle().show();
			if (!confirm) return;
			await SaleService.deleteType(saleType);
			this.$emit("refresh");
		},
	},
	created(){

	},
	components: {
		AppSaleTypeNew
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
